import React, { useEffect, useState } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/** Кнопка быстрого перехода в конец/начало таблицы по горизонтали.
 * scrollRef - ref на контейнер с горизонтальным скроллом
 **/

const ScrollButton = ({ scrollRef }) => {
  const [{ canScroll, isAtEnd }, setState] = useState({ canScroll: false, isAtEnd: false });

  useEffect(() => {
    const el = scrollRef?.current;
    if (!el) return;

    const update = () => {
      setState({
        canScroll: el.scrollWidth > el.clientWidth + 1,
        isAtEnd: el.scrollLeft + el.clientWidth >= el.scrollWidth - 1,
      });
    };

    update();
    el.addEventListener('scroll', update);

    const observer = new ResizeObserver(update);
    observer.observe(el);
    if (el.firstElementChild) observer.observe(el.firstElementChild);

    return () => {
      el.removeEventListener('scroll', update);
      observer.disconnect();
    };
  }, [scrollRef]);

  if (!canScroll) return null;

  const handleClick = () => {
    const el = scrollRef.current;
    el?.scrollTo({ left: isAtEnd ? 0 : el.scrollWidth, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={isAtEnd ? 'В начало таблицы' : 'В конец таблицы'}
      className="absolute right-1 top-4 z-20 w-7 h-7 flex items-center justify-center rounded-full bg-white border border-gray-300 text-gray-500 hover:text-primary-500 hover:border-primary-500 transition">
      {isAtEnd ? <ArrowBackIcon fontSize="small" /> : <ArrowForwardIcon fontSize="small" />}
    </button>
  );
};

export default ScrollButton;
